// extracted by mini-css-extract-plugin
export default {"sep":"Footer_sep__hSEX1"};